// extracted by mini-css-extract-plugin
var _1 = "bpl__rules-list__disclaimer__d_Qnr";
var _2 = "bpl__rules-list__disclaimer-mark__ApqHR";
var _3 = "bpl__rules-list__list__item__bGtQu";
var _4 = "bpl__rules-list__list__item__number__p4e0j";
var _5 = "bpl__rules-list__list__item__text__BlAaL";
export { _1 as "rules-list__disclaimer", _2 as "rules-list__disclaimer-mark", _3 as "rules-list__list__item", _4 as "rules-list__list__item__number", _5 as "rules-list__list__item__text" }
